


























import { Component, Mixins, Watch, Prop } from 'vue-property-decorator';
import { enumData } from '@/decorators';
import FirmTableMixins from '../../mixins/firmTableMixins';

@Component
export default class SignUp extends Mixins(FirmTableMixins) {
  @enumData('Customer/ServiceBodyTypeEnum')
  protected serviceBodyTypeEnum: TypeBase.EnumListItem[] = [];
  @enumData('Customer/SignBodyStatusEnum')
  protected signBodyStatusEnum: TypeBase.EnumListItem[] = [];
  @enumData('Customer/ContractTypeEnum')
  protected contractTypeEnum: TypeBase.EnumListItem[] = [];
  @enumData('Customer/ContractStateEnum')
  protected contractStateEnum: TypeBase.EnumListItem[] = [];
  protected columns: TypeBase.TableColumn[] = [];
  protected tabeData: TypeCertification.IntegrationContractItem[] = [];
  @Prop({ type: Boolean, default: false })
  private startupInfoLoading!: boolean;
  @Watch('data', { immediate: true })
  protected onDataChange(data: TypeCertification.CustomerStartupInfo): void {
    if (data.firm_list) {
      this.tabeData = this.integrationTableData(data.firm_list);
    }
  }
  // 整合表格数据
  protected integrationTableData(data: TypeCertification.CustomerFirmComposite[]): TypeCertification.IntegrationContractItem[] {
    const newData: TypeCertification.IntegrationContractItem[] = [];
    data.forEach((item: TypeCertification.CustomerFirmComposite) => {
      const itemCp = this.$util.deepCopy<TypeCertification.CustomerFirmComposite>(item);
      const businessTypeList = item.sign_body_info.sign_business_type_list;
      if (item.contract_list && item.contract_list.length) {
        item.contract_list.forEach((child: TypeCertification.Contract, index: number) => {
          const nd = Object.assign({
            certification_phone_number: itemCp.certification_info.certification_phone_number,
          }, itemCp.sign_body_info, child) as TypeCertification.IntegrationContractItem;
          if (index === 0) {
            nd.mergeRow = item.contract_list.length;
          }
          newData.push(nd);
        });
      } else if (businessTypeList instanceof Array && businessTypeList.length) {
        businessTypeList.forEach((bt: number, index: number) => {
          const isSigned = item.sign_body_info.contracted_business_list &&
            item.sign_body_info.contracted_business_list.indexOf(bt) > -1 ? true : false;
          const nd = Object.assign({
            certification_phone_number: itemCp.certification_info.certification_phone_number,
          }, itemCp.sign_body_info, {
            contract_type: bt,
            contract_state: isSigned ? this.$enum.mine.ContractStateEnum.SIGNED_CUSTOMER :
              this.$enum.mine.ContractStateEnum.NOCONTRACTLIST,
          }) as TypeCertification.IntegrationContractItem;
          if (index === 0) {
            nd.mergeRow = businessTypeList.length;
          }
          newData.push(nd);
        });
      } else {
        newData.push(Object.assign({
          certification_phone_number: itemCp.certification_info.certification_phone_number,
        }, itemCp.sign_body_info, {
          contract_state: this.$enum.mine.ContractStateEnum.NOCONTRACTLIST,
          mergeRow: 1,
        }) as TypeCertification.IntegrationContractItem);
      }
    });
    return newData;
  }
  protected mergeCellTable(value: string | number, row: TypeCertification.IntegrationContractItem, enumList: TypeBase.EnumListItem[], isMerge: boolean = true) {
    const obj = {
      children: enumList.length ? this.$util.getEnumTextByValue(enumList, value) : value,
      attrs: {
        rowSpan: 0,
      },
    };
    obj.attrs.rowSpan = isMerge ? row.mergeRow || 0 : 1;
    return obj;
  }

  protected created(): void {
    const h = this.$createElement;
    this.columns = [
      {
        title: this.t('账户编号'),
        filterEmpty: true,
        dataIndex: 'account_code',
        customRender: (value: string | number, row: TypeCertification.IntegrationContractItem, index: number) => {
          return this.mergeCellTable(value, row, []);
        },
      },
      {
        title: this.t('公司名称'),
        filterEmpty: true,
        dataIndex: 'sign_body_name',
        customRender: (value: string | number, row: TypeCertification.IntegrationContractItem, index: number) => {
          return this.mergeCellTable(value, row, []);
        },
      },
      {
        title: this.t('服务主体'),
        dataIndex: 'service_body_type',
        customRender: (value: string | number, row: TypeCertification.IntegrationContractItem, index: number) => {
          return this.mergeCellTable(value, row, this.serviceBodyTypeEnum);
        },
      },
      {
        title: this.t('注册国家/区域'),
        dataIndex: 'register_area_name',
        customRender: (value: string | number, row: TypeCertification.IntegrationContractItem, index: number) => {
          return this.mergeCellTable(value, row, []);
        },
      },
      {
        title: this.t('审核状态'),
        filterEmpty: true,
        dataIndex: 'sign_body_status',
        customRender: (value: string | number, row: TypeCertification.IntegrationContractItem, index: number) => {
          return {
            children: <div>
              {this.signBodyStatusEnum.length ? this.$util.getEnumTextByValue(this.signBodyStatusEnum, value) : value}
              {row.rejected_remark && row.sign_body_status === this.$enum.mine.SignBodyStatusEnum.AUDIT_NOT_PASS ? <a-popover
                content={row.rejected_remark}>
                <a-icon type='exclamation-circle'
                  class='ml-5 other-tag' />
              </a-popover> : ''}
              {row.register_area_code === this.$enum.mine.RegisterAreaCodeEnum.CN && row.sign_body_status === this.$enum.mine.SignBodyStatusEnum.DRAFT ?
                <a href='javascript:'
                  class='ml-5'
                  onClick={() => {
                    this.handleApprove(String(row.account_code))
                  }}>{this.t('认证')}</a>
                : ''}
              {
                row.register_area_code !== this.$enum.mine.RegisterAreaCodeEnum.CN && (row.sign_body_status === this.$enum.mine.SignBodyStatusEnum.DRAFT || row.sign_body_status === this.$enum.mine.SignBodyStatusEnum.AUDIT_NOT_PASS) ?
                  <a href='javascript:'
                    class='ml-5'
                    onClick={() => {
                      this.handleSubmit(String(row.account_code))
                    }}>{this.t('提交审核')}</a> : ''}
              {row.sign_body_status === this.$enum.mine.SignBodyStatusEnum.DRAFT || row.sign_body_status === this.$enum.mine.SignBodyStatusEnum.AUDIT_NOT_PASS ?
                <a href='javascript:'
                  class='ml-5'
                  onClick={() => {
                    this.handleEdit(String(row.account_code));
                  }}>{this.t('编辑')}</a> : ''
              }
            </div>,
            attrs: {
              rowSpan: row.mergeRow || 0,
            },
          };
        },
      },
      {
        title: this.t('账单模板'),
        dataIndex: 'bill_lang_type_text',
        filterEmpty: true,
      },
      {
        title: this.t('签约业务'),
        dataIndex: 'contract_type',
        customRender: (value: string | number, row: TypeCertification.IntegrationContractItem, index: number) => {
          return this.mergeCellTable(value, row, this.contractTypeEnum, false);
        },
      },
      {
        title: this.t('签约状态'),
        dataIndex: 'contract_state',
        width: 200,
        fixed: 'right',
        customRender: (value: string | number, row: TypeCertification.IntegrationContractItem, index: number) => {
          const text = this.$util.getEnumTextByValue(this.contractStateEnum, value);
          const obj = {
            children: (
              <div>
                {text}&nbsp;&nbsp;
                {(value === this.$enum.mine.ContractStateEnum.SIGNED_SELF &&
                  row.sign_body_contract_id
                ) ? (
                  <a-button
                    id='welcome_sign_contract_submit'
                    onClick={() => {
                      this.$router.push({
                        path: '/welcome/sign_contract',
                        query: {
                          contract_id: row.sign_body_contract_id.toString(),
                          phone: row.certification_phone_number,
                          account_code: row.account_code,
                        },
                      });
                    }}
                    type='primary'
                  >
                    <a-icon type='audit' />
                    {this.t('签约')}
                  </a-button>
                ) : (value === this.$enum.mine.ContractStateEnum.SIGNED_CUSTOMER &&
                  row.sign_body_contract_id) ? (
                  <a href={this.$config.downloadContractUrl + '?id=' + row.sign_body_contract_id}>
                    <a-icon type='download' />
                  </a>
                ) : (
                  ''
                )}
              </div>
            ),
            attrs: {
              rowSpan: 1,
            },
          };
          return obj;
        },
      },
    ];
  }
}
